import {Component, OnInit, ViewChild} from '@angular/core';
import {LanguageType} from '../shared/types';
import {AudioPlayerComponent} from '../audio-player/audio-player.component';

const HEBREW_TITLE_IMG = 'assets/GH-title-HE.png';
const ENGLISH_TITLE_IMG = 'assets/GH-title-EN.png';
const CHAPTER1_HEBREW = 'האגם הגדול';
const CHAPTER1_ENGLISH = 'The Pond';
const CHAPTER2_HEBREW = 'מה שנשכח';
const CHAPTER2_ENGLISH = 'Forgotten';
const CHAPTER3_HEBREW = 'שבע טחנות';
const CHAPTER3_ENGLISH = 'Sheva Tahanot';
const CHAPTER4_HEBREW = 'כיכר התורמים';
const CHAPTER4_ENGLISH = 'Donors Square';
const CHAPTER5_HEBREW = 'ראש ציפור';
const CHAPTER5_ENGLISH = 'Bird Head';
const CHAPTER6_HEBREW = 'החורשה';
const CHAPTER6_ENGLISH = 'The Grove';
const CHAPTER7_HEBREW = 'קאירן גשרי ירח';
const CHAPTER7_ENGLISH = 'Moon Bridges Cairn';

interface Page {
  name: string;
  src?: string;
  title?: string;
  image?: string;
}

@Component({
  selector: 'app-main-page',
  templateUrl: './main-page.component.html',
  styleUrls: ['./main-page.component.scss'],
})
export class MainPageComponent implements OnInit {
  @ViewChild(AudioPlayerComponent, {static: false}) audioPlayer!: AudioPlayerComponent;

  currentPageIndex = 0;
  readonly numChapters = 7;
  readonly pagesOrder: Page[] = [
    {name: 'welcome'},
    {name: 'pick-gender'},
    {name: 'navigation-description'},
    {name: 'audio', src: 'assets/audio/1-f.mp3', title: CHAPTER1_HEBREW, image: 'assets/1-pond.png'},
    {name: 'audio', src: 'assets/audio/2-f.mp3', title: CHAPTER2_HEBREW, image: 'assets/2-forget.png'},
    {name: 'audio', src: 'assets/audio/3-f.mp3', title: CHAPTER3_HEBREW, image: 'assets/3-sheva.png'},
    {name: 'audio', src: 'assets/audio/4-f.mp3', title: CHAPTER4_HEBREW, image: 'assets/4-donor.png'},
    {name: 'audio', src: 'assets/audio/5-f.mp3', title: CHAPTER5_HEBREW, image: 'assets/5-bird.png'},
    {name: 'audio', src: 'assets/audio/6-f.mp3', title: CHAPTER6_HEBREW, image: 'assets/6-grove.png'},
    {name: 'audio', src: 'assets/audio/7-f.mp3', title: CHAPTER7_HEBREW, image: 'assets/7-cairn.png'},
    {name: 'final'},
  ];
  language: LanguageType = 'hebrew';
  isFemaleGender = true;
  titleImg = HEBREW_TITLE_IMG;

  constructor() { }

  ngOnInit() {
  }

  onGenderPicking(isFemale: boolean): void {
    this.goToPage(this.currentPageIndex + 1);
    this.isFemaleGender = isFemale;
    this.updatingAudioSrc();
  }

  updatingAudioSrc(): void {
    const isHebrew = this.language === 'hebrew';
    for (let i = 0; i < this.numChapters; i++) {
      this.pagesOrder[i+3].src = isHebrew ?
        (this.isFemaleGender? `assets/audio/${i+1}-f.mp3`: `assets/audio/${i+1}-m.mp3`) :
        `assets/audio/${i+1}-e.mp3`;
    }
  }

  onLanguageChange(language: LanguageType): void {
    this.language = language;
    const isHebrew = this.language === 'hebrew';
    this.titleImg = isHebrew ? HEBREW_TITLE_IMG : ENGLISH_TITLE_IMG;

    // Update audio titles.
    this.pagesOrder[3].title = isHebrew ? CHAPTER1_HEBREW : CHAPTER1_ENGLISH;
    this.pagesOrder[4].title = isHebrew ? CHAPTER2_HEBREW : CHAPTER2_ENGLISH;
    this.pagesOrder[5].title = isHebrew ? CHAPTER3_HEBREW : CHAPTER3_ENGLISH;
    this.pagesOrder[6].title = isHebrew ? CHAPTER4_HEBREW : CHAPTER4_ENGLISH;
    this.pagesOrder[7].title = isHebrew ? CHAPTER5_HEBREW : CHAPTER5_ENGLISH;
    this.pagesOrder[8].title = isHebrew ? CHAPTER6_HEBREW : CHAPTER6_ENGLISH;
    this.pagesOrder[9].title = isHebrew ? CHAPTER7_HEBREW : CHAPTER7_ENGLISH;
    this.updatingAudioSrc();
  }

  goToPage(pageNum: number): void {
    this.currentPageIndex = pageNum;
    if (this.audioPlayer) {
      this.audioPlayer.pauseAudio();
    }
  }

}
